<agr-page-toolbar
  [pageTitle]="pageTitle"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createFecalScoring()"
  data-test="fecal-scoring--overview"
>
  <ng-container actions>
    <mat-select
      multiple
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-placeholder="{{ 'fecal-scoring-overview.location-selector' | translate }}"
      data-test="location-selector"
      (selectionChange)="changeLocation($event)"
      [compareWith]="areLocationsEqual"
      [value]="selectedLocations"
    >
      <mat-option *ngFor="let location of locationItems" [value]="location">
        {{ location.name }}
      </mat-option>
    </mat-select>
  </ng-container>

  <div class="spacing--margin-horizontal spacing--margin-top introtext">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column">
          <span class="text--small label">
            {{ 'fecal-scoring.overview.intro-header' | translate }}<br />
          </span>
          <span class="text--small label text--bold spacing--margin-top">
            {{ 'fecal-scoring.overview.intro-introductie-titel' | translate }}
          </span>
          <span class="text--small label spacing--margin-top">
            {{ 'fecal-scoring.overview.intro-introductie-paragraph1' | translate }}
          </span>
          <span class="text--small label spacing--margin-top">
            {{ 'fecal-scoring.overview.intro-introductie-paragraph2' | translate }}
          </span>
          <div class="spacing--margin-top flex--row flex--wrap penscorediv">
            <span class="text--small label align-center spacing--margin-top">
              {{ 'fecal-scoring.detail.penscore.fecalnormal' | translate }}
            </span>
            <div class="flex--column penscoreimgdiv">
              <img src="assets/images/FecalScoring/FecalNormal.jpg" class="penscoreimg" />
            </div>
          </div>
          <div class="spacing--margin-top flex--row flex--wrap penscorediv">
            <span class="text--small label align-center">
              {{ 'fecal-scoring.detail.penscore.fecalsoft' | translate }}
            </span>
            <div class="flex--column penscoreimgdiv">
              <img src="assets/images/FecalScoring/FecalSoft.jpg" class="penscoreimg" />
            </div>
          </div>
          <div class="spacing--margin-top flex--row flex--wrap penscorediv">
            <span class="text--small label align-center">
              {{ 'fecal-scoring.detail.penscore.fecalmild' | translate }}
            </span>
            <div class="flex--column penscoreimgdiv">
              <img src="assets/images/FecalScoring/FecalMild.jpg" class="penscoreimg" />
            </div>
          </div>
          <div class="spacing--margin-top flex--row flex--wrap penscorediv">
            <span class="text--small label align-center">
              {{ 'fecal-scoring.detail.penscore.fecalmoderate' | translate }}
            </span>
            <div class="flex--column penscoreimgdiv">
              <img src="assets/images/FecalScoring/FecalModerate.jpg" class="penscoreimg" />
            </div>
          </div>
          <div class="spacing--margin-top spacing--margin-bottom flex--row flex--wrap penscorediv">
            <span class="text--small label align-center">
              {{ 'fecal-scoring.detail.penscore.fecalsevere' | translate }}
            </span>
            <div class="flex--column penscoreimgdiv">
              <img src="assets/images/FecalScoring/FecalSevere.jpg" class="penscoreimg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="tableConfig$ | async as tableConfig">
    <agr-table
      *ngIf="tableConfig"
      [emptyTitle]="'fecal-scoring.overview.no-fecal-scoring.title' | translate"
      [emptyDescription]="'fecal-scoring.overview.no-fecal-scoring.description' | translate"
      emptyImage="assets/images/pigs_001.jpg"
      [config]="tableConfig"
      class="table"
    ></agr-table>
  </ng-container>
</agr-page-toolbar>
